import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import SettingsPanelSection from '../SettingsPanelSection';
import FeaturesEditor from '../../components/FeaturesEditor/FeaturesEditor';
import { createActions } from '../../store';
import { saveFeaturesPanelVisited } from '../../../../../utilities/storageUtilities';

const SettingsPanelSectionFeatures = ({ featuresPanelVisited, setProperty }) => {
    useEffect(() => {
        saveFeaturesPanelVisited(true);

        if (!featuresPanelVisited)
            setProperty('featuresPanelVisited', true);
        // Marking the panel as visited must run once per mount, not on state changes.
    }, []);

    return (
        <SettingsPanelSection title='Features' id='settings-panel-section-features'>
            <FeaturesEditor />
        </SettingsPanelSection>
    );
};

const mapStateToProps = (state) => {
    const { featuresPanelVisited } = state.create;
    return { featuresPanelVisited };
};

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(createActions.setProperty(key, value));
    return { setProperty };
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPanelSectionFeatures);
